import { OnInit, OnDestroy, ElementRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from '../../dashboard';
import { Data } from '../../helpers';
import { ErrorHandlerService } from '../../services';
import { DateTimeConverstionService } from '../../services/index';
import * as moment from 'moment';
var timestamp = moment(new Date()).format('DDMMYYYYhhmmss').toString() + moment.tz.zone(Intl.DateTimeFormat().resolvedOptions().timeZone.toString()).abbr(360);
var CreatecourseComponent = /** @class */ (function () {
    function CreatecourseComponent(data, dashboardService, router, route, errorHandlerService, timeZoneConverstionService) {
        this.data = data;
        this.dashboardService = dashboardService;
        this.router = router;
        this.route = route;
        this.errorHandlerService = errorHandlerService;
        this.timeZoneConverstionService = timeZoneConverstionService;
        this.insertImageSettings = {
            saveUrl: process.env.API_URL + "/session/inlineimage?timestamp=" + timestamp + "&jwtToken=" + localStorage.getItem('authorization'),
            path: process.env.COURSE_IMAGE_URL + this.dashboardService.userdata.userDetailsId + timestamp + "/"
        };
        this.timezone2 = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
        this.isCourseDateEntryDisabled = false;
        this.isEndDateCalculatedFromSchedule = false;
        this.temp = "";
        this.query = '';
        this.isEdit = false;
        this.repeat = false;
        this.imageUploaded = false;
        this.docUploaded = false;
        this.showFieldForEdit = true;
        this.disabledForEdit = false;
        this.date = new Date();
        this.minDate = moment(new Date()).toDate();
        this.isfree = false;
        this.freeCourse = {};
        this.selectDefaultTime = false;
        this.summary = '';
        this.start = "";
        this.end = "";
        this.endDateTime = "";
        this.duration = "";
        this.meta = {};
        this.catogory = [];
        this.expcourse = [];
        this.coursefees = [];
        this.time = [];
        this.durationArray = [];
        this.previewurl = "";
        this.slideDeckFileName = "";
        this.dayofWeeks = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        this.formData = null;
        this.formDataDoc = null;
        this.editCourse = {};
        this.subscriptions = [];
        this.tools = {
            items: ['Undo', 'Redo', '|',
                'Bold', 'Italic', 'Underline', 'StrikeThrough', '|',
                'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|',
                'SubScript', 'SuperScript', '|',
                'LowerCase', 'UpperCase', '|',
                'Formats', 'Alignments', '|', 'OrderedList', 'UnorderedList', '|',
                'Indent', 'Outdent', '|', 'CreateLink',
                'Image', '|', 'ClearFormat', 'Print', 'SourceCode', '|', 'FullScreen']
        };
        this.basictools = {
            items: ['Undo', 'Redo', '|',
                'Bold', 'Italic', 'Underline', 'LowerCase', 'UpperCase', '|',
                'Formats', 'Alignments', '|', 'OrderedList', 'UnorderedList']
        };
        this.staticSponsor = [];
        this.queSessionId = 0;
        this.createCourse = {
            expectedAttendees: "",
            isNewCourse: true,
            notifyPastAttendees: true,
            cohostUser: null,
            registrationQuestionnaireId: null,
            sponsorshipRequired: false,
            sponsorshipLevels: [
                {
                    sponsorshipLevel: "Silver",
                    benefits: "<div>Example:</div><ul><li>Company logo and link on this session</li><li>Announcement by session owner during the session</li></ul>",
                    amount: 500,
                    show: true
                },
                {
                    sponsorshipLevel: "Gold",
                    benefits: "<div>Example:</div><ul><li>Company logo and link on this session</li><li>Announcement by session owner during the session</li><li>2 min time during the session to showcase your company or product</li></ul>",
                    amount: 1000,
                    show: true
                },
                {
                    sponsorshipLevel: "Platinum",
                    benefits: "<div>Example:</div><ul><li>Company logo and link on this session</li><li>Announcement by session owner during the session</li><li>5 min time during the session to showcase your company or product</li><li>Include company logo and link in social media as proud sponsor</li></ul>",
                    amount: 5000,
                    show: true
                }
            ],
            slideDeckFileNameOriginal: null,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone.toString(),
            startTime: {},
            endTime: {},
            user: {},
            tc: null,
            categories: [{
                    "courseCategoryName": "",
                    "categoryFullText": ""
                }],
            currentSchedule: {
                repeateEveryCount: '',
                monthlyRepeatTypeStr: '',
                endOfMeetingTypeStr: 'Occurence',
                csoccurence: "",
                repeateEveryCounttemp: "",
                csstartDate: "",
                endOfMeetingTypeInputStr: 'Occurence',
                monthlyRepeatTypeInputStr: 'DayOfMonth',
                repeattype: 'None',
                repeatTypeStr: 'None',
                selectedDaysOfWeektempStr: this.dayofWeeks,
                csendDate: Date,
                repeatcheckbox: ""
            }
        };
        this.repeatcheckbox = '';
        this.timezoneTopbar = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
        this.msgTitle = "";
        this.msgContent = "";
        this.popUp = false;
        // Popup dialog settings
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [""];
        this.showErrorMessageTitle = "Error!";
        this.showErrorMessageWidthInPercentage = "20%";
        this.isValidationError = false;
        this.showErrorPopupWidthInPercentage = "100%";
        this.isSignUp = true;
        this.pleaseWait = true;
        this.maxUpload = false;
        this.invalidUpload = false;
        this.uploadedFiles = [];
        this.editSponsore = { price: 0, content: "", type: "silver" };
        this.editSponsoreShow = true;
        this.userToresults = [];
        this.usersTo = [];
        this.addCoHostShow = false;
        this.isSessionCreating = true;
        this.wrongTime = false;
        this.questionnairePopup = false;
        this.isCourseDateEntryDisabled = false;
        if (this.data.storage != undefined && this.data.storage.coursepreview != undefined) {
            console.log(this.data.storage.coursepreview.coursedata);
            this.editCourse = this.data.storage.coursepreview.coursedata;
            if (this.editCourse.imageURL != "") {
                this.previewurl = this.editCourse.imageURL;
            }
            if (this.editCourse.slideDeckFileName != "") {
                this.slideDeckFileName = null;
            }
        }
        this.createCourse.currentSchedule.csendDate = moment(new Date()).toDate();
    }
    CreatecourseComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    CreatecourseComponent.prototype.addCoHost = function () {
        this.addCoHostShow = true;
    };
    CreatecourseComponent.prototype.removeCohost = function (userId) {
        var sessionCoHostId = {};
        if (this.isEdit) {
            sessionCoHostId = {
                sessionCoHostId: userId,
                isSessionCoHostActive: false
            };
            this.createCourse.sessionCoHostData = sessionCoHostId;
            this.createCourse.cohostUser = null;
        }
        else {
            this.createCourse.sessionCoHostData = null;
            this.createCourse.cohostUser = null;
        }
    };
    CreatecourseComponent.prototype.searchusers = function (event) {
        var _this = this;
        var s2 = this.dashboardService.userTo(event.query).subscribe(function (data) {
            console.log(data);
            _this.usersTo = data;
            _this.userToresults = _this.usersTo.map(function (user) {
                return {
                    username: user.content,
                    userDetailsId: user.entityId,
                    imageURL: user.imageURL,
                    userBaseType: (user.userBaseType == undefined) ? null : user.userBaseType,
                    educationalInstitution: (user.educationalInstitution == undefined) ? null : user.educationalInstitution,
                    campus: (user.campus == undefined) ? null : user.campus
                };
            });
            console.log(_this.userToresults);
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s2);
    };
    CreatecourseComponent.prototype.onSelectCoHost = function () {
        // let sessionCoHostId = {}
        // if (this.isEdit) {
        //     sessionCoHostId = {
        //         sessionCoHostId: this.sessionCoHostId[0].userDetailsId,
        //         isSessionCoHostActive: true
        //     }
        // } else {
        //     sessionCoHostId = {
        //         sessionCoHostId: this.sessionCoHostId[0].userDetailsId
        //     }
        // }
        // this.createCourse.sessionCoHostData = sessionCoHostId;
        // console.log("this.createCourse", this.createCourse);
    };
    CreatecourseComponent.prototype.onUnselectCoHost = function () {
        // if (this.isEdit) {
        //     this.createCourse.sessionCoHostData.isSessionCoHostActive = false;
        // } else {
        //     this.createCourse.sessionCoHostData = null;
        // }
        // console.log("this.createCourse", this.createCourse);
    };
    CreatecourseComponent.prototype.addCoHostSave = function () {
        if (this.sessionCoHostId.length > 0) {
            var sessionCoHostId = {};
            if (this.isEdit) {
                sessionCoHostId = {
                    sessionCoHostId: this.sessionCoHostId[0].userDetailsId,
                    isSessionCoHostActive: true
                };
            }
            else {
                sessionCoHostId = {
                    sessionCoHostId: this.sessionCoHostId[0].userDetailsId
                };
            }
            this.getUser(this.sessionCoHostId[0].userDetailsId);
            this.createCourse.sessionCoHostData = sessionCoHostId;
            this.createCourse.cohostUser = {
                userName: this.sessionCoHostId[0].username,
                imageURL: this.sessionCoHostId[0].imageURL,
                userBaseType: this.sessionCoHostId[0].userBaseType,
                educationalInstitution: this.sessionCoHostId[0].educationalInstitution,
                campus: this.sessionCoHostId[0].campus
            };
            console.log("this.createCourse", this.createCourse);
            this.addCoHostShow = false;
        }
    };
    CreatecourseComponent.prototype.getUser = function (id) {
        var _this = this;
        this.showSpinner = true;
        var ss3 = this.dashboardService.profileVisitsbyId(id).subscribe(function (data) {
            console.log(data);
            _this.sessionCoHostId[0].campus = data.campus;
            _this.sessionCoHostId[0].educationalInstitution = data.eduIns;
            _this.sessionCoHostId[0].userBaseType = data.userType;
            _this.createCourse.cohostUser = {
                userName: _this.sessionCoHostId[0].username,
                imageURL: _this.sessionCoHostId[0].imageURL,
                userBaseType: _this.sessionCoHostId[0].userBaseType,
                educationalInstitution: _this.sessionCoHostId[0].educationalInstitution,
                campus: _this.sessionCoHostId[0].campus
            };
            _this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(ss3);
    };
    CreatecourseComponent.prototype.addCoHostClose = function () {
        this.sessionCoHostId = null;
        this.addCoHostShow = false;
    };
    CreatecourseComponent.prototype.timeZone2change = function (data) {
        this.createCourse.displayStartDateOnlyConverted = this.timeZoneConverstionService.convertTimezone(data, 'date', this.createCourse.courseStartDTime);
        this.createCourse.timeZoneConverted = data;
        this.createCourse.displayStopDateOnlyConverted = this.timeZoneConverstionService.convertTimezone(data, 'date', this.createCourse.courseEndDTime);
        this.createCourse.startTimeConverted = this.timeZoneConverstionService.convertTimezone(data, 'time', this.createCourse.courseStartDTime);
        this.createCourse.endTimeConverted = this.timeZoneConverstionService.convertTimezone(data, 'time', this.createCourse.courseEndDTime);
        localStorage.setItem('timezone', data);
    };
    CreatecourseComponent.prototype.courseImageUpload = function (event) {
        var _this = this;
        this.formData = null;
        this.formData = new FormData();
        var date = new Date();
        var fileList = event.target.files;
        if (fileList.length > 0) {
            var file = fileList[0];
            this.formData.append('file', file, file.name);
            this.imageUploaded = true;
        }
        if (event.target.files && event.target.files[0]) {
            var reader = new FileReader();
            //this.previewurl = reader.result;
            reader.onload = function (event) {
                _this.previewurl = event.target['result'];
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    };
    CreatecourseComponent.prototype.editSponsoreClick = function (sponsor) {
        this.editSponsore.price = sponsor.amount;
        this.editSponsore.content = sponsor.benefits;
        this.editSponsore.type = sponsor.sponsorshipLevel;
        this.editSponsoreShow = true;
    };
    CreatecourseComponent.prototype.editSponsoreClose = function () {
        this.editSponsore.price = 0;
        this.editSponsore.content = "";
        this.editSponsore.type = "Silver";
        this.editSponsoreShow = false;
    };
    CreatecourseComponent.prototype.editSponsoreSave = function () {
        var _this = this;
        this.createCourse.sponsorshipLevels.forEach(function (element) {
            if (element.sponsorshipLevel == _this.editSponsore.type) {
                element.amount = _this.editSponsore.price;
                element.benefits = _this.editSponsore.content;
                _this.editSponsoreClose();
            }
        });
    };
    CreatecourseComponent.prototype.closeErrorPopup = function () {
        this.showOnlyOverlay = false;
        this.showErrorMessageTitle = "";
        this.showErrorMessages = [];
        this.isValidationError = false;
        this.showErrorPopupWidthInPercentage = "100%";
        this.showErrorModalDialog = false;
        this.isSignUp = false;
        this.pleaseWait = false;
    };
    CreatecourseComponent.prototype.onRemoveFile = function (e) {
        console.log('ee', e);
        this.formDataDoc = null;
    };
    CreatecourseComponent.prototype.onClearFile = function () {
        console.log("clear");
        this.formDataDoc = null;
    };
    CreatecourseComponent.prototype.courseDocUpload = function (event) {
        var _this = this;
        console.log('document', event);
        for (var _i = 0, _a = event.files; _i < _a.length; _i++) {
            var file = _a[_i];
            this.uploadedFiles.push(file);
        }
        this.maxUpload = false;
        this.invalidUpload = false;
        this.formDataDoc = null;
        this.formDataDoc = new FormData();
        var date = new Date();
        var fileList = event.files;
        if (fileList.length > 0) {
            var file = fileList[0];
            this.formDataDoc.append('file', file, file.name);
            this.docUploaded = true;
            this.createCourse.slideDeckFileNameOriginal = file.name;
        }
        else {
            this.createCourse.slideDeckFileNameOriginal = null;
        }
        if (event.files && event.files[0]) {
            var reader = new FileReader();
            reader.onload = function (event) {
                _this.slideDeckFileName = event.target['result'];
            };
            // if (event.files[0].size > 5120000) {
            //     this.maxUpload = true;
            //     setTimeout(() => {
            //         this.maxUpload = false;
            //     }, 5000);
            //     this.DocInputVariable.nativeElement.value = "";
            //     this.formDataDoc = null;
            // }
            // else if (event.files[0].type != "image/jpeg" &&
            //     event.files[0].type != "application/pdf" &&
            //     event.files[0].type != "image/png" &&
            //     event.files[0].type != "application/x-zip-compressed" &&
            //     event.files[0].type != "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
            //     event.files[0].type != "application/vnd.openxmlformats-officedocument.wordprocessingml.document" &&
            //     event.files[0].type != "application/vnd.openxmlformats-officedocument.presentationml.presentation") {
            //     this.invalidUpload = true;
            //     setTimeout(() => {
            //         this.invalidUpload = false;
            //     }, 5000);
            //     this.DocInputVariable.nativeElement.value = "";
            //     this.formDataDoc = null;
            // }
            console.log('doc', event.files);
        }
    };
    CreatecourseComponent.prototype.timeZonechange = function (data) {
        console.log(data);
        this.timezoneTopbar = data;
        console.log('voila ' + this.timezoneTopbar);
        localStorage.setItem('timezone', data);
        this.createCourse.timeZone = this.timezoneTopbar;
    };
    CreatecourseComponent.prototype.downloadDoc = function (courseId, slidedeck) {
        var _this = this;
        this.showSpinner = true;
        this.showOnlyOverlay = true;
        this.showErrorMessageTitle = 'Info!!';
        this.showErrorMessages.push("Please wait... Downloading document...");
        this.isValidationError = false;
        this.showErrorPopupWidthInPercentage = "100%";
        this.showErrorModalDialog = true;
        this.isSignUp = true;
        this.pleaseWait = true;
        var name = (slidedeck != null && slidedeck != undefined) ? slidedeck : 'doc';
        var doc = this.dashboardService.getDoc(courseId).subscribe(function (data) {
            _this.showSpinner = false;
            _this.showOnlyOverlay = false;
            _this.showErrorMessageTitle = '';
            _this.showErrorMessages = [];
            _this.isValidationError = false;
            _this.showErrorModalDialog = false;
            _this.isSignUp = false;
            _this.pleaseWait = false;
            console.log("doc", data["_body"]);
            var blob = new Blob([data["_body"]], { type: data.headers.get('Content-Type') });
            //saveAs(blob, "tset.jpg");
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = name;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(doc);
    };
    CreatecourseComponent.prototype.ngAfterViewInit = function () {
        this.maximize();
        $(document).ready(function () {
            $("#submitBtn").click(function () {
                setTimeout(function () {
                    if ($('.errorDiv:visible:first').offset() != undefined) {
                        $('html, body').animate({
                            scrollTop: $('.errorDiv:visible:first').offset().top - 150
                        }, 500);
                    }
                }, 200);
            });
        });
    };
    CreatecourseComponent.prototype.maximize = function () {
        var that = this;
        setTimeout(function () {
            $("#alltoolRTE_toolbar_Maximize").on("click", function () {
                $("#alltoolRTE").addClass("zIndex");
                that.minimize();
            });
        }, 1000);
    };
    CreatecourseComponent.prototype.minimize = function () {
        var that = this;
        setTimeout(function () {
            $("#alltoolRTE_toolbar_Minimize").on("click", function () {
                $("#alltoolRTE").removeClass("zIndex");
                that.maximize();
                setTimeout(function () {
                    $("#alltoolRTE_toolbar_nav").trigger("click");
                }, 500);
            });
        }, 1000);
    };
    CreatecourseComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isCourseDateEntryDisabled = false;
        this.createCourse = {
            expectedAttendees: "",
            isNewCourse: true,
            notifyPastAttendees: true,
            cohostUser: null,
            registrationQuestionnaireId: null,
            sponsorshipRequired: false,
            sponsorshipLevels: [
                {
                    sponsorshipLevel: "Silver",
                    benefits: "<div>Example:</div><ul><li>Company logo and link on this session</li><li>Announcement by session owner during the session</li></ul>",
                    amount: 500,
                    show: true
                },
                {
                    sponsorshipLevel: "Gold",
                    benefits: "<div>Example:</div><ul><li>Company logo and link on this session</li><li>Announcement by session owner during the session</li><li>2 min time during the session to showcase your company or product</li></ul>",
                    amount: 1000,
                    show: true
                },
                {
                    sponsorshipLevel: "Platinum",
                    benefits: "<div>Example:</div><ul><li>Company logo and link on this session</li><li>Announcement by session owner during the session</li><li>5 min time during the session to showcase your company or product</li><li>Include company logo and link in social media as proud sponsor</li></ul>",
                    amount: 5000,
                    show: true
                }
            ],
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone.toString(),
            startTime: {},
            endTime: {},
            user: {},
            categories: [{
                    "courseCategoryName": "",
                    "categoryFullText": ""
                }],
            currentSchedule: {
                repeateEveryCount: '',
                monthlyRepeatTypeStr: '',
                endOfMeetingTypeStr: 'Occurence',
                csoccurence: "",
                repeateEveryCounttemp: "",
                csstartDate: "",
                endOfMeetingTypeInputStr: 'Occurence',
                monthlyRepeatTypeInputStr: 'DayOfMonth',
                repeattype: 'None',
                repeatTypeStr: 'None',
                selectedDaysOfWeektempStr: this.dayofWeeks,
                csendDate: Date
            }
        };
        this.timezoneTopbar = localStorage.getItem('timezone');
        this.createCourse.StartDate = moment(new Date(), 'MM/DD/YYYY').toDate();
        if (this.timezoneTopbar) {
            this.timezoneTopbar = this.timezoneTopbar;
            this.createCourse.timeZone = this.timezoneTopbar;
        }
        var staticData = this.dashboardService.courseStaticMetaData().subscribe(function (data) {
            _this.catogory = data.categories;
            _this.coursefees = data.courseFees;
            _this.time = data.times;
            _this.staticSponsor = data.sponsorshipLevels;
            if (_this.staticSponsor.length > 0) {
                _this.createCourse.sponsorshipLevels.forEach(function (spl) {
                    if (_this.staticSponsor.includes(spl.sponsorshipLevel)) {
                        spl.show = true;
                    }
                    else {
                        spl.show = false;
                    }
                });
            }
            _this.durationArray = data.times.slice(1);
            _this.editSponsoreShow = false;
            console.log("The Edit Course==>");
            console.log(_this.editCourse);
            _this.createCourse.courseType = "Public";
            if (_this.editCourse.categories) {
                _this.createCourse.categories[0].courseCategoryId = _this.editCourse.categories[0].courseCategoryId;
                _this.createCourse.courseFullName = _this.editCourse.courseFullName;
                _this.createCourse.courseShortName = _this.editCourse.courseShortName;
                _this.createCourse.url = _this.editCourse.url;
                _this.createCourse.courseSummary = (_this.editCourse.courseSummary == "<p>undefined</p>") ? "" : _this.editCourse.courseSummary;
                // this.StartDate = moment(this.editCourse.displayStartDateOnly, 'MM/DD/YYYY').toString();
                // this.EndDate = moment(this.editCourse.displayStopDateOnly, 'MM/DD/YYYY').toDate();
                _this.createCourse.StartDate = _this.editCourse.StartDate;
                _this.createCourse.EndDate = _this.editCourse.EndDate;
                _this.startTime(_this.editCourse.startTime.timeId);
                _this.endTime(_this.editCourse.endTime.timeId);
                _this.populateCourseEndDateAndTime();
                _this.createCourse.startTime.timeId = _this.editCourse.startTime.timeId;
                _this.createCourse.endTime.timeId = _this.editCourse.endTime.timeId;
                //this.start = this.editCourse.startTime.display;
                //this.end = this.editCourse.endTime.display;
                _this.createCourse.timeZone = _this.timezoneTopbar;
                _this.createCourse.courseType = _this.editCourse.courseType;
                _this.createCourse.notifyPastAttendees = (_this.editCourse.notifyPastAttendees == undefined) ? true : _this.editCourse.notifyPastAttendees;
                _this.createCourse.currentSchedule = _this.editCourse.currentSchedule;
                if (_this.createCourse.currentSchedule.repeatcheckbox) {
                    _this.repeatDone();
                }
                _this.repeatcheckbox = _this.editCourse.currentSchedule.repeatcheckbox;
                _this.createCourse.isEndDateCalculatedFromSchedule = _this.editCourse.isEndDateCalculatedFromSchedule;
                // if(element.currentSchedule != null){
                //     this.createCourse.currentSchedule = element.currentSchedule;
                // }else{
                //     this.createCourse.currentSchedule = null;
                // }
                _this.createCourse.cost = _this.editCourse.cost;
                if (_this.editCourse.cost != 0 && _this.editCourse.cost && '' && _this.editCourse.cost != null) {
                    _this.createCourse.fee = 'Paid';
                }
                else {
                    _this.createCourse.fee = 'Free';
                }
                _this.courseFeechange(_this.createCourse.fee);
                _this.createCourse.fee = _this.editCourse.fee;
                _this.createCourse.cohostUser = _this.editCourse.cohostUser;
                _this.createCourse.sessionCoHostData = _this.editCourse.sessionCoHostData;
                _this.createCourse.sponsorshipRequired = _this.editCourse.sponsorshipRequired;
                _this.createCourse.sponsorshipLevels = _this.editCourse.sponsorshipLevels;
                _this.createCourse.courseScheduleSummaryLong = _this.editCourse.courseScheduleSummaryLong;
                _this.createCourse.slideDeckFileName = _this.editCourse.slideDeckFileName;
                _this.createCourse.slideDeckFileNameOriginal = _this.editCourse.slideDeckFileNameOriginal;
                if (_this.editCourse.slideDeckFileNameOriginal != null && _this.editCourse.slideDeckFileNameOriginal != undefined && _this.editCourse.slideDeckFileNameOriginal != "") {
                    _this.createCourse.isNewCourse = false;
                    _this.slideDeckFileName = _this.editCourse.slideDeckFileName;
                }
                else {
                    _this.createCourse.isNewCourse = true;
                    _this.slideDeckFileName = null;
                }
                _this.createCourse.registrationQuestionnaireId = (_this.editCourse.registrationQuestionnaireId != undefined) ? _this.editCourse.registrationQuestionnaireId : null;
                _this.createCourse.expectedAttendees = _this.editCourse.expectedAttendees;
                console.log("The course Being initialized ==>");
                console.log(_this.createCourse);
            }
            else {
                _this.createCourse.courseSummary = "";
                _this.selectDefaultTime = true;
                _this.createCourse.categories[0].courseCategoryId = "-1";
            }
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(staticData);
        var s1 = this.dashboardService.courseMetaData().subscribe(function (data) {
            _this.meta = data;
            Object.keys(data.expiredCourses).map(function (key) {
                _this.expcourse.push(data.expiredCourses[key]);
            });
            var s2 = _this.route.queryParams.subscribe(function (params) {
                _this.query = params['sessionId'] || 0;
                _this.isEdit = params['isEdit'] || false;
                if (_this.query != '0') {
                    var s3 = _this.dashboardService.getCourse(_this.query).subscribe(function (data) {
                        console.log(data);
                        if (data.owner != true) {
                            alert("You are not the owner!");
                            return;
                        }
                        _this.createCourse = data;
                        _this.createCourse.categories[0].courseCategoryId = data.categories[0].courseCategoryId;
                        _this.createCourse.courseFullName = data.courseFullName;
                        _this.createCourse.courseShortName = data.courseShortName;
                        _this.createCourse.url = data.url;
                        _this.createCourse.courseSummary = (data.courseSummary == "<p>undefined</p>") ? "" : data.courseSummary;
                        // this.StartDate = moment(data.displayStartDateOnly).format('MM/DD/YYYY').toString();
                        // this.EndDate = moment(data.displayStopDateOnly).format('MM/DD/YYYY').toString();
                        _this.startTime(data.startTime.timeId);
                        _this.endTime(data.endTime.timeId);
                        _this.createCourse.startTime.timeId = data.startTime.timeId;
                        _this.createCourse.slideDeckFileName = (data.slideDeckFileName != undefined && _this.isEdit) ? data.slideDeckFileName : null;
                        _this.createCourse.slideDeckFileNameOriginal = (data.slideDeckFileNameOriginal != undefined && _this.isEdit) ? data.slideDeckFileNameOriginal : null;
                        //this.createCourse.endTime.timeId = data.endTime.timeId;
                        //this.start = data.startTime.display;
                        //this.end = data.endTime.display;
                        _this.createCourse.timeZone = _this.timezoneTopbar;
                        _this.createCourse.courseType = data.courseType;
                        _this.createCourse.notifyPastAttendees = (data.notifyPastAttendees == undefined) ? true : data.notifyPastAttendees;
                        _this.createCourse.sponsorshipRequired = data.sponsorshipRequired;
                        _this.createCourse.sponsorshipLevels = data.sponsorshipLevels;
                        // if(element.currentSchedule != null){
                        //     this.createCourse.currentSchedule = element.currentSchedule;
                        // }else{
                        //     this.createCourse.currentSchedule = null;
                        // }
                        _this.createCourse.cost = data.cost;
                        if (data.cost != 0 || data.cost != '' || data.cost != null) {
                            _this.createCourse.fee = 'Paid';
                        }
                        else {
                            _this.createCourse.fee = 'Free';
                        }
                        if (data.coHosts != undefined && data.coHosts[0] != undefined) {
                            _this.createCourse.cohostUser = {
                                userName: data.coHosts[0].firstName + " " + data.coHosts[0].lastName,
                                imageURL: data.coHosts[0].profilePicName,
                                userBaseType: (data.coHosts[0].userBaseType == undefined) ? null : data.coHosts[0].userBaseType,
                                educationalInstitution: (data.coHosts[0].educationalInstitution == undefined) ? null : data.coHosts[0].educationalInstitution,
                                campus: (data.coHosts[0].campus == undefined) ? null : data.coHosts[0].campus
                            };
                        }
                        else {
                            _this.createCourse.cohostUser = null;
                        }
                        //show the image
                        if (data.hasOwnProperty('imageURL')) {
                            _this.previewurl = data.imageURL;
                        }
                        if (data.hasOwnProperty('slideDeckFileName')) {
                            _this.slideDeckFileName = data.slideDeckFileName;
                        }
                        if (_this.isEdit != false) {
                            _this.showFieldForEdit = false;
                            _this.disabledForEdit = true;
                            if (localStorage.getItem('timezone')) {
                                _this.timezone2 = localStorage.getItem('timezone');
                            }
                            if (_this.timezone2) {
                                _this.timeZone2change(_this.timezone2);
                            }
                        }
                        else {
                            //create similar course should null out the id
                            _this.createCourse.courseId = null;
                            _this.createCourse.encryptedCourseId = '';
                        }
                        _this.createCourse.currentSchedule = {
                            repeateEveryCount: '',
                            monthlyRepeatTypeStr: '',
                            endOfMeetingTypeStr: 'Occurence',
                            csoccurence: "",
                            repeateEveryCounttemp: "",
                            csstartDate: "",
                            endOfMeetingTypeInputStr: 'Occurence',
                            monthlyRepeatTypeInputStr: 'DayOfMonth',
                            repeattype: 'None',
                            repeatTypeStr: 'None',
                            selectedDaysOfWeektempStr: _this.dayofWeeks,
                            csendDate: Date,
                            repeatcheckbox: ""
                        };
                    }, function (error) {
                        _this.handleError(error);
                    });
                    _this.subscriptions.push(s3);
                }
            });
            _this.subscriptions.push(s2);
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s1);
    };
    CreatecourseComponent.prototype.submitForEditingCourse = function () {
        var _this = this;
        if (this.createCourse.tc == false) {
            this.createInfoAlert("Terms & Conditions is required");
            return;
        }
        if (this.createCourse.courseStatus != "Approved" && this.createCourse.courseStatus != "Submitted") {
            this.createInfoAlert("The session must be in 'Approved' or 'Submitted' state for editing");
            return;
        }
        this.showSpinner = true;
        console.log("logging edited data" + this.createCourse);
        this.showSpinner = true;
        //User uploaded a new image
        if (this.imageUploaded == true || this.docUploaded == true) {
            if (this.imageUploaded == true) {
                console.log("ging to image upload ");
                var s58 = this.dashboardService.courseImageUpload(this.formData).subscribe(function (data) {
                    _this.showSpinner = false;
                    _this.createCourse.imageURL = data;
                    _this.formData = null;
                    console.log("Successfully Uploaded the Image. The this.createCourse.imageURL ==>" + _this.createCourse.imageURL);
                    _this.callEditService();
                }, function (error) {
                    _this.showSpinner = false;
                    _this.formData = null;
                    _this.createCourse.imageURL = "";
                    console.log("Could not upload the image. The this.createCourse.imageURL ==>" + _this.createCourse.imageURL);
                    _this.createInfoAlert("There was an error uploading the Session Image, falling back to default image.");
                    //User didnt upload a new image
                    _this.callEditService();
                });
                this.subscriptions.push(s58);
            }
            if (this.docUploaded == true) {
                console.log("ging to doc upload ");
                var s58 = this.dashboardService.courseDocUpload(this.formDataDoc).subscribe(function (data) {
                    _this.showSpinner = false;
                    _this.createCourse.slideDeckFileName = data;
                    _this.formDataDoc = null;
                    console.log("Successfully Uploaded the Doc. The this.createCourse.slideDeckFileName ==>" + _this.createCourse.slideDeckFileName);
                    _this.callEditService();
                }, function (error) {
                    _this.showSpinner = false;
                    _this.formDataDoc = null;
                    _this.createCourse.slideDeckFileName = "";
                    console.log("Could not upload the image. The this.createCourse.slideDeckFileName ==>" + _this.createCourse.slideDeckFileName);
                    _this.createInfoAlert("There was an error uploading the Session Doc.");
                    //User didnt upload a new image
                    _this.callEditService();
                });
                this.subscriptions.push(s58);
            }
        }
        else {
            //User didnt upload a new image
            this.callEditService();
        }
    };
    CreatecourseComponent.prototype.callEditService = function () {
        var _this = this;
        var s99 = this.dashboardService.editCourse(this.createCourse).subscribe(function (data2) {
            _this.data.storage = null;
            _this.showSpinner = false;
            console.log(data2);
            if (data2.isSuccess == false) {
                _this.createInfoAlert("following error =" + data2.errorMessage);
            }
            else {
                _this.createInfoAlert("Successfully updated the session details");
                _this.router.navigate(['dashboard/courseaccount']);
            }
        }, function (error) {
            _this.showSpinner = false;
            console.log(error);
            _this.handleError(error);
        });
        this.subscriptions.push(s99);
    };
    CreatecourseComponent.prototype.addprop = function (e) {
        console.log("The current schedule in addProp==>");
        console.log(this.createCourse.currentSchedule);
        if (!this.validateDates()) {
            e.target.checked = false;
            return false;
        }
        if (e.target.checked) {
            this.createCourse.currentSchedule.isScheduleValid = true;
            if (this.createCourse.EndDate) {
                this.temp = moment(this.createCourse.EndDate).format('MM/DD/YYYY').toString();
            }
            this.repeat = true;
            if (!(this.createCourse.currentSchedule.csoccurence != null && this.createCourse.currentSchedule.csoccurence.trim() != '')) {
                if (this.createCourse.currentSchedule.repeattype) {
                    if (this.createCourse.currentSchedule.repeattype == 'Daily' || this.createCourse.currentSchedule.repeattype == 'Yearly') {
                        if (this.createCourse.currentSchedule.occurence) {
                            this.createCourse.currentSchedule.csoccurence = this.createCourse.currentSchedule.occurence;
                        }
                        else {
                            this.createCourse.currentSchedule.csoccurence = "5";
                            this.createCourse.currentSchedule.occurence = Number(this.createCourse.currentSchedule.csoccurence);
                        }
                    }
                    else {
                        if (this.createCourse.currentSchedule.occurence) {
                            this.createCourse.currentSchedule.csoccurence = this.createCourse.currentSchedule.occurence;
                        }
                        else {
                            this.createCourse.currentSchedule.csoccurence = "35";
                            this.createCourse.currentSchedule.occurence = Number(this.createCourse.currentSchedule.csoccurence);
                        }
                    }
                }
                else {
                    if (this.createCourse.currentSchedule.occurence) {
                        this.createCourse.currentSchedule.csoccurence = this.createCourse.currentSchedule.occurence;
                    }
                    else {
                        this.createCourse.currentSchedule.csoccurence = "5";
                        this.createCourse.currentSchedule.occurence = Number(this.createCourse.currentSchedule.csoccurence);
                    }
                }
            }
            if (this.createCourse.StartDate != '') {
                this.createCourse.currentSchedule.csstartDate = moment(this.createCourse.StartDate).format('MM/DD/YYYY').toString();
            }
            else {
                this.createCourse.currentSchedule.csstartDate = moment(new Date()).format('MM/DD/YYYY');
            }
            //this.summaryGenerate();
        }
        else {
            this.isCourseDateEntryDisabled = false;
            this.repeat = false;
            this.summary = '';
            this.resetSchedule();
            console.log("this.createCourse.isEndDateCalculatedFromSchedule");
            console.log(this.createCourse.isEndDateCalculatedFromSchedule);
            if (this.createCourse.isEndDateCalculatedFromSchedule == true) {
                console.log("Resetting end date to the csstartdate");
                //this.createCourse.EndDate = moment(this.createCourse.currentSchedule.csstartDate).toDate();
            }
            else {
                if (this.temp != '') {
                    console.log("Resetting end date to the temp date");
                    //this.createCourse.EndDate = moment(this.temp, 'MM/DD/YYYY').toDate();
                }
                console.log("Keeping end date as is");
            }
            console.log("Resetting the schedule==>");
            console.log(this.createCourse.currentSchedule);
        }
    };
    CreatecourseComponent.prototype.SaveAsDraft = function () {
    };
    CreatecourseComponent.prototype.resetSchedule = function () {
        this.createCourse.currentSchedule.repeateEveryCount = '';
        this.createCourse.currentSchedule.monthlyRepeatTypeStr = '';
        this.createCourse.currentSchedule.endOfMeetingTypeStr = 'Occurence';
        this.createCourse.currentSchedule.csoccurence = "";
        this.createCourse.currentSchedule.repeateEveryCounttemp = "1";
        this.createCourse.currentSchedule.csstartDate = moment(this.createCourse.StartDate).format('MM/DD/YYYY').toString();
        this.createCourse.currentSchedule.endOfMeetingTypeInputStr = 'Occurence';
        this.createCourse.currentSchedule.monthlyRepeatTypeInputStr = 'DayOfMonth';
        this.createCourse.currentSchedule.repeattype = '';
        this.createCourse.currentSchedule.selectedDaysOfWeektempStr = this.dayofWeeks;
        this.createCourse.currentSchedule.csendDate = null;
        this.createCourse.currentSchedule.repeatcheckbox = "";
        this.createCourse.currentSchedule.isScheduleValid = false;
        this.createCourse.currentSchedule.repeatTypeStr = 'None';
    };
    CreatecourseComponent.prototype.addpropOn = function (e) {
        if (e.target.checked) {
            if (this.createCourse.currentSchedule.repeattype == 'Weekly') {
                if (this.createCourse.currentSchedule.csoccurence == '') {
                    this.createCourse.currentSchedule.csoccurence = "35";
                }
                console.log(this.createCourse.currentSchedule.csoccurence);
                var contractMoment = moment(this.createCourse.StartDate, 'MM/DD/YYYY');
                this.createCourse.currentSchedule.csendDate = moment(contractMoment).add(this.createCourse.currentSchedule.csoccurence, 'days').toDate();
                this.createCourse.currentSchedule.csendDate = moment(this.createCourse.currentSchedule.csendDate, 'DD/MM/YYYY').toDate();
            }
            else if (this.createCourse.currentSchedule.repeattype == 'Daily') {
                if (this.createCourse.currentSchedule.csoccurence == '') {
                    this.createCourse.currentSchedule.csoccurence = "5";
                }
                var contractMoment = moment(this.createCourse.StartDate, 'MM/DD/YYYY');
                this.createCourse.currentSchedule.csendDate = moment(contractMoment).add(this.createCourse.currentSchedule.csoccurence, 'days').toDate();
                this.createCourse.currentSchedule.csendDate = moment(this.createCourse.currentSchedule.csendDate, 'DD/MM/YYYY').toDate();
            }
            else if (this.createCourse.currentSchedule.repeattype == 'EveryMonWedFriday') {
                if (this.createCourse.currentSchedule.csoccurence == '') {
                    this.createCourse.currentSchedule.csoccurence = "35";
                }
                var contractMoment = moment(this.createCourse.StartDate, 'MM/DD/YYYY');
                this.createCourse.currentSchedule.csendDate = moment(contractMoment).add(this.createCourse.currentSchedule.csoccurence, 'days').toDate();
                this.createCourse.currentSchedule.csendDate = moment(this.createCourse.currentSchedule.csendDate, 'DD/MM/YYYY').toDate();
            }
            else if (this.createCourse.currentSchedule.repeattype == 'EveryTueThu') {
                if (this.createCourse.currentSchedule.csoccurence == '') {
                    this.createCourse.currentSchedule.csoccurence = "35";
                }
                var contractMoment = moment(this.createCourse.StartDate, 'MM/DD/YYYY');
                this.createCourse.currentSchedule.csendDate = moment(contractMoment).add(this.createCourse.currentSchedule.csoccurence, 'days').toDate();
                this.createCourse.currentSchedule.csendDate = moment(this.createCourse.currentSchedule.csendDate, 'DD/MM/YYYY').toDate();
            }
            else if (this.createCourse.currentSchedule.repeattype == 'EveryWeekDay') {
                if (this.createCourse.currentSchedule.csoccurence == '') {
                    this.createCourse.currentSchedule.csoccurence = "35";
                }
                var contractMoment = moment(this.createCourse.StartDate, 'MM/DD/YYYY');
                this.createCourse.currentSchedule.csendDate = moment(contractMoment).add(this.createCourse.currentSchedule.csoccurence, 'days').toDate();
                this.createCourse.currentSchedule.csendDate = moment(this.createCourse.currentSchedule.csendDate, 'DD/MM/YYYY').toDate();
            }
            else if (this.createCourse.currentSchedule.repeattype == 'Monthly') {
                if (this.createCourse.currentSchedule.csoccurence == '') {
                    this.createCourse.currentSchedule.csoccurence = "35";
                }
                var contractMoment = moment(this.createCourse.StartDate, 'MM/DD/YYYY');
                this.createCourse.currentSchedule.csendDate = moment(contractMoment).add(this.createCourse.currentSchedule.csoccurence, 'days').toDate();
                this.createCourse.currentSchedule.csendDate = moment(this.createCourse.currentSchedule.csendDate, 'DD/MM/YYYY').toDate();
            }
            else if (this.createCourse.currentSchedule.repeattype == 'Yearly') {
                if (this.createCourse.currentSchedule.csoccurence == '') {
                    this.createCourse.currentSchedule.csoccurence = "5";
                }
                var contractMoment = moment(this.createCourse.StartDate, 'MM/DD/YYYY');
                this.createCourse.currentSchedule.csendDate = moment(contractMoment).add(this.createCourse.currentSchedule.csoccurence, 'days').toDate();
                this.createCourse.currentSchedule.csendDate = moment(this.createCourse.currentSchedule.csendDate, 'DD/MM/YYYY').toDate();
            }
        }
        else {
            this.createCourse.currentSchedule.csendDate = moment(new Date()).toDate();
        }
        //this.summaryGenerate();
    };
    CreatecourseComponent.prototype.cancleRepeat = function () {
        this.isCourseDateEntryDisabled = false;
        this.repeat = false;
        this.repeatcheckbox = '';
        this.summary = '';
        if (this.temp != '') {
            //this.createCourse.EndDate = moment(this.temp, 'MM/DD/YYYY').toDate();
        }
        this.createCourse.currentSchedule.repeatTypeStr = 'None';
        this.createCourse.isEndDateCalculatedFromSchedule = false;
    };
    CreatecourseComponent.prototype.courseFeechange = function (val) {
        this.isfree = false;
        if (val == 'Free') {
            this.isfree = true;
            this.createCourse.cost = 0.00;
        }
    };
    CreatecourseComponent.prototype.expireCourse = function (id) {
        var _this = this;
        if (id == 'Select a course') {
            return;
        }
        this.showSpinner = true;
        var courseDetails = this.dashboardService.getCourse(id).subscribe(function (data) {
            _this.createCourse.categories[0].courseCategoryId = data.categories[0].courseCategoryId;
            _this.createCourse.courseFullName = data.courseFullName;
            _this.createCourse.courseShortName = data.courseShortName;
            _this.createCourse.url = data.url;
            _this.createCourse.courseSummary = (data.courseSummary == "<p>undefined</p>") ? "" : data.courseSummary;
            _this.createCourse.similarCourseId = data.courseId;
            // this.StartDate = moment(data.displayStartDateOnly, 'MM/DD/YYYY').toString();
            // this.EndDate = moment(data.displayStopDateOnly, 'MM/DD/YYYY').toDate();
            _this.startTime(data.startTime.timeId);
            _this.endTime(data.endTime.timeId);
            _this.createCourse.startTime.timeId = data.startTime.timeId;
            //this.createCourse.endTime.timeId = data.endTime.timeId;
            //this.start = data.startTime.display;
            //this.end = data.endTime.display;
            // this.createCourse.timezone = data.timezone;
            _this.createCourse.courseType = data.courseType;
            _this.createCourse.notifyPastAttendees = (data.courseType == undefined) ? true : data.notifyPastAttendees;
            // if(data.currentSchedule != null){
            //     this.createCourse.currentSchedule = data.currentSchedule;
            // }else{
            //     this.createCourse.currentSchedule = null;
            // }
            _this.createCourse.cost = data.cost;
            if (data.imageURL != "") {
                _this.createCourse.imageURL = data.imageURL;
                _this.previewurl = _this.createCourse.imageURL;
            }
            if (data.slideDeckFileName != "") {
                _this.createCourse.slideDeckFileName = data.slideDeckFileName;
                _this.createCourse.slideDeckFileNameOriginal = data.slideDeckFileNameOriginal;
                _this.slideDeckFileName = _this.createCourse.slideDeckFileName;
            }
            if (data.cost != 0 || data.cost != '' || data.cost != null) {
                _this.createCourse.fee = 'Paid';
            }
            else {
                _this.createCourse.fee = 'Free';
            }
            _this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
            _this.showSpinner = false;
        });
        this.subscriptions.push(courseDetails);
    };
    CreatecourseComponent.prototype.resetAll = function () {
        //this.createCourse.currentSchedule = null;
        if (this.createCourse.StartDate != '') {
            this.createCourse.currentSchedule.csstartDate = moment(this.createCourse.StartDate).format('MM/DD/YYYY').toString();
        }
        else {
            this.createCourse.currentSchedule.csstartDate = moment(new Date()).format('MM/DD/YYYY');
        }
        if (this.createCourse.currentSchedule.repeattype == 'Daily' || this.createCourse.currentSchedule.repeattype == 'Yearly'
            || this.createCourse.currentSchedule.repeattype == 'Monthly') {
            this.createCourse.currentSchedule.csoccurence = "5";
            this.createCourse.currentSchedule.occurence = Number(this.createCourse.currentSchedule.csoccurence);
        }
        else {
            this.createCourse.currentSchedule.csoccurence = "35";
            this.createCourse.currentSchedule.occurence = Number(this.createCourse.currentSchedule.csoccurence);
        }
        //this.summaryGenerate();
    };
    CreatecourseComponent.prototype.repeatDone = function () {
        var _this = this;
        //alert('called')
        console.log("The createCourse.StartDate");
        console.log(this.createCourse.StartDate);
        console.log(new Date());
        if (this.createCourse.currentSchedule.repeateEveryCounttemp) {
            this.createCourse.currentSchedule.repeateEveryCount = Number(this.createCourse.currentSchedule.repeateEveryCounttemp);
        }
        else {
            this.createCourse.currentSchedule.repeateEveryCount = 1;
        }
        if (this.createCourse.currentSchedule.csstartDate) {
            console.log("The createCourse.currentSchedule.csstartDate is ==>" + this.createCourse.currentSchedule.csstartDate);
            this.createCourse.currentSchedule.startDate = moment(this.createCourse.currentSchedule.csstartDate).format('MM/DD/YYYY').toString();
        }
        else {
            //this.createCourse.currentSchedule.createCourse.currentSchedule.csstartDate =
            this.createCourse.currentSchedule.createCourse.currentSchedule.csstartDate = new Date();
            this.createCourse.currentSchedule.startDate = moment(new Date()).format('MM/DD/YYYY');
        }
        this.createCourse.StartDate = moment(this.createCourse.currentSchedule.startDate, 'MM/DD/YYYY').toDate();
        this.createCourse.currentSchedule.monthlyRepeatTypeStr = this.createCourse.currentSchedule.monthlyRepeatTypeInputStr;
        this.createCourse.currentSchedule.repeatTypeStr = this.createCourse.currentSchedule.repeattype;
        this.createCourse.currentSchedule.endOfMeetingTypeStr = this.createCourse.currentSchedule.endOfMeetingTypeInputStr;
        if (this.createCourse.currentSchedule.csoccurence) {
            this.createCourse.currentSchedule.occurence = this.createCourse.currentSchedule.csoccurence;
        }
        if (this.createCourse.currentSchedule.repeattype == 'Weekly') {
            this.createCourse.currentSchedule.selectedDaysOfWeekStr = this.createCourse.currentSchedule.selectedDaysOfWeektempStr.filter(function (v) { return !((typeof (v) === "boolean")); });
        }
        if (this.createCourse.currentSchedule.endOfMeetingTypeInputStr == 'OnDate' && this.createCourse.currentSchedule.csendDate) {
            this.createCourse.currentSchedule.endDate = moment(this.createCourse.currentSchedule.csendDate).format('MM/DD/YYYY').toString() + " " + this.end + ":00";
            ;
        }
        console.log("The this.createCourse.currentSchedule.selectedDaysOfWeekStr");
        console.log(this.createCourse.currentSchedule.selectedDaysOfWeekStr);
        //alert(this.createCourse.currentSchedule.endOfMeetingTypeInputStr);
        if (this.createCourse.currentSchedule.endOfMeetingTypeInputStr == 'OnDate') {
            this.createCourse.currentSchedule.occurence = '0';
        }
        var courseForEndDate = this.populateCreateCourseForEndDate();
        var calculatedEndDateData = null;
        this.showSpinner = true;
        var s4 = this.dashboardService.deriveCourseScheduledEndDate(courseForEndDate).subscribe(function (data) {
            _this.showSpinner = false;
            calculatedEndDateData = data;
            var dateString = calculatedEndDateData.value.dateValue;
            var time = calculatedEndDateData.value.time;
            var dateFormat = calculatedEndDateData.value.dateFormat.toUpperCase();
            _this.createCourse.currentSchedule.endDate = dateString + " " + time + ":00";
            console.log("this.createCourse.currentSchedule.endDate calculated from Server");
            console.log(_this.createCourse.currentSchedule.endDate);
            _this.summary = calculatedEndDateData.value.summary;
            _this.isCourseDateEntryDisabled = true;
        }, function (error) {
            _this.cancleRepeat();
            console.log('Error occurred');
            console.log(error);
            _this.handleError(error);
        });
        this.subscriptions.push(s4);
        this.repeat = false;
        console.log(this.createCourse);
        this.createCourse.isEndDateCalculatedFromSchedule = true;
    };
    CreatecourseComponent.prototype.weekdatChange = function (ind, val, event) {
        if (event.target.checked) {
            this.createCourse.currentSchedule.selectedDaysOfWeektempStr[ind] = val;
        }
        else {
            this.createCourse.currentSchedule.selectedDaysOfWeektempStr[ind] = false;
        }
        console.log(this.createCourse.currentSchedule.selectedDaysOfWeektempStr);
        //this.summaryGenerate();
    };
    CreatecourseComponent.prototype.summaryGenerate = function (isEndDateToBeDisplayed) {
        var s = this.summary;
        var days = '';
        var occurenceUntil = "";
        this.createCourse.currentSchedule.selectedDaysOfWeektempStr.forEach(function (element) {
            if (element != false) {
                days += element + ", ";
            }
        });
        var start_temp = Number(moment(this.createCourse.currentSchedule.csstartDate).local().startOf('month'));
        var end_temp = Number(moment(this.createCourse.currentSchedule.csstartDate).local().endOf('month'));
        var nrofWeeks = (moment.duration(end_temp - start_temp).weeks() + 1).toString();
        //alert(nrofWeeks)
        if (nrofWeeks == '1') {
            nrofWeeks = 'first';
        }
        if (nrofWeeks == '2') {
            nrofWeeks = 'Second';
        }
        if (nrofWeeks == '2') {
            nrofWeeks = 'Second';
        }
        if (nrofWeeks == '3') {
            nrofWeeks = 'Third';
        }
        if (nrofWeeks == '4') {
            nrofWeeks = 'Fourth';
        }
        if (nrofWeeks == '5') {
            nrofWeeks = 'Fifth';
        }
        var dayom = (moment(this.createCourse.currentSchedule.csstartDate).day()).toString();
        if (dayom == '1') {
            dayom = 'Sunday';
        }
        if (dayom == '2') {
            dayom = 'Monday';
        }
        if (dayom == '2') {
            dayom = 'Tuesday';
        }
        if (dayom == '3') {
            dayom = 'Wednesday';
        }
        if (dayom == '4') {
            dayom = 'Thursday';
        }
        if (dayom == '5') {
            dayom = 'Friday';
        }
        if (dayom == '6') {
            dayom = 'Saturday';
        }
        if (isEndDateToBeDisplayed == true && this.createCourse.currentSchedule.endOfMeetingTypeInputStr == 'Occurence') {
            occurenceUntil = " until " + moment(this.createCourse.currentSchedule.endDate).format('MM/DD/YYYY').toString();
        }
        var temp = (this.createCourse.currentSchedule.endOfMeetingTypeInputStr == 'Occurence') ?
            this.createCourse.currentSchedule.csoccurence + " times" + occurenceUntil :
            "until " + moment(this.createCourse.currentSchedule.csendDate).format('MM/DD/YYYY').toString();
        var temp1 = (this.createCourse.currentSchedule.monthlyRepeatTypeInputStr == 'DayOfMonth') ?
            moment(this.createCourse.currentSchedule.csstartDate).format('DD').toString() : nrofWeeks + " " + dayom;
        if (this.createCourse.currentSchedule.repeattype == 'Weekly') {
            this.summary = this.createCourse.currentSchedule.repeattype + " on " + days + " " + temp;
        }
        if (this.createCourse.currentSchedule.repeattype == 'EveryWeekDay') {
            this.summary = "Weekly on weekdays " + temp;
        }
        if (this.createCourse.currentSchedule.repeattype == 'EveryWeekDay') {
            this.summary = "Weekly on weekdays " + temp;
        }
        if (this.createCourse.currentSchedule.repeattype == 'EveryMonWedFriday') {
            this.summary = "Weekly on Monday,Wednesday,Friday " + temp;
        }
        if (this.createCourse.currentSchedule.repeattype == 'EveryTueThu') {
            this.summary = "Weekly on Tuesday,Thursday " + temp;
        }
        if (this.createCourse.currentSchedule.repeattype == 'Monthly') {
            this.summary = "Monthly on day " + temp1 + ", " + temp;
        }
        if (this.createCourse.currentSchedule.repeattype == 'Yearly') {
            this.summary = "Anually on " + moment(this.createCourse.currentSchedule.csstartDate).format("M DD") + ", " + temp;
        }
        if (this.createCourse.currentSchedule.repeattype == 'Daily') {
            this.summary = "Daily," + temp;
        }
        this.summary = s;
        console.log(this.summary);
        //this.EndDate = moment(this.createCourse.currentSchedule.csendDate, 'DD/MM/YYYY').toDate();
    };
    CreatecourseComponent.prototype.navigateWithData = function (url, param) {
        var _this = this;
        if (!this.wrongTime) {
            this.populateCourseEndDateAndTime();
            console.log(this.meta);
            if (this.meta.user.memberShipPlan.minCourseFee > this.createCourse.cost && !this.isfree) {
                this.createInfoAlert("Please select higher amount, you current member ship doesn’t allow less than USD " + this.meta.user.memberShipPlan.minCourseFee);
            }
            else if ((this.meta.user.memberShipPlan.planType != "Basic") && (this.createCourse.expectedAttendees > 100)) {
                this.createInfoAlert("Please upgrade your membership to allow up to 500 participants. You can also change the number of participants later from My Session");
            }
            else {
                if (this.isfree) {
                    this.createCourse.courseStartDateStr = moment(this.createCourse.StartDate).format('MM/DD/YYYY').toString() + " " + this.start + ":00";
                    this.createCourse.displayStartDateOnly = moment(this.createCourse.StartDate).format('MM/DD/YYYY').toString();
                    this.createCourse.displayStopDateOnly = moment(this.createCourse.EndDate).format('MM/DD/YYYY').toString();
                    this.createCourse.displayStartDate = moment(this.createCourse.StartDate).format('MM/DD/YYYY').toString() + " " + this.start + ":00";
                    this.createCourse.displayStopDate = moment(this.createCourse.EndDate).format('MM/DD/YYYY').toString() + " " + this.end + ":00";
                    this.createCourse.courseStartDateStr = moment(this.createCourse.StartDate).format('MM/DD/YYYY').toString() + " " + this.start + ":00";
                    this.createCourse.courseEndDateStr = moment(this.createCourse.EndDate).format('MM/DD/YYYY').toString() + " " + this.end + ":00";
                    this.createCourse.courseScheduleEndDateStr = this.createCourse.currentSchedule.endDate;
                    this.createCourse.currentSchedule.repeatcheckbox = this.repeatcheckbox;
                    this.createCourse.courseStatus = "Submitted";
                    if (this.repeatcheckbox == 'false' || this.repeatcheckbox == '') {
                        this.createCourse.currentSchedule.repeatTypeStr = 'None';
                    }
                    this.freeCourse.startDateStr = this.createCourse.courseStartDateStr;
                    this.freeCourse.timeZone = this.createCourse.timeZone;
                    this.freeCourse.courseToSave = this.createCourse;
                    if (this.freeCourse.startDateStr === null || this.freeCourse.startDateStr === undefined) {
                        console.log("please select schedule");
                        return;
                    }
                    console.log("calling free duration check with=" + this.freeCourse.courseToSave);
                    this.showSpinner = true;
                    var s9 = this.dashboardService.canScheduleFreeCourse(this.freeCourse).subscribe(function (data) {
                        console.log(data);
                        if (data.error) {
                            alert(data.error);
                        }
                        else {
                            _this.navigateReal(url, param);
                        }
                        _this.freeCourse.startDateStr = null;
                        _this.showSpinner = false;
                    }, function (error) {
                        _this.showSpinner = false;
                        _this.handleError(error);
                        console.log(error);
                    });
                    this.subscriptions.push(s9);
                }
                else {
                    this.navigateReal(url, param);
                }
            }
        }
    };
    CreatecourseComponent.prototype.navigateReal = function (url, param) {
        var _this = this;
        console.log("The RepeatCheckBox ==>" + this.repeatcheckbox);
        if (this.createCourse.StartDate != '' && this.createCourse.EndDate != null) {
            this.createCourse = param;
            /*if(this.repeatcheckbox == ''){
                this.createCourse.currentSchedule = null
            }*/
            if (!(this.formData == null || this.editCourse.imageURL) || !(this.formDataDoc == null || this.editCourse.slideDeckFileName)) {
                this.showSpinner = true;
                console.log("this.createCourse.docCheckbox", this.createCourse.docCheckbox);
                //console.log("this.formDataDoc.has('file')", this.formDataDoc.has("file"));
                if (this.formDataDoc != null && this.createCourse.docCheckbox != true) {
                    this.showSpinner = false;
                    return;
                }
                if (!(this.formData == null)) {
                    var s5 = this.dashboardService.courseImageUpload(this.formData).subscribe(function (data) {
                        _this.showSpinner = false;
                        _this.createCourse.imageURL = data;
                        _this.formData = null;
                        _this.uploadDoc(url);
                        console.log("Successfully Uploaded the Image. The this.createCourse.imageURL ==>" + _this.createCourse.imageURL);
                    }, function (error) {
                        _this.showSpinner = false;
                        4;
                        _this.formData = null;
                        _this.createCourse.imageURL = null;
                        console.log("Could not upload the image. The this.createCourse.imageURL ==>" + _this.createCourse.imageURL);
                        _this.createInfoAlert("There was an error uploading the Session Image, falling back to default image.");
                    });
                    this.subscriptions.push(s5);
                }
                if (this.formData == null) {
                    this.uploadDoc(url);
                }
            }
            else {
                if (this.editCourse.imageURL || (this.previewurl != "") || this.createCourse.imageURL
                    || this.editCourse.slideDeckFileName || (this.slideDeckFileName != "")) {
                    if (this.createCourse.imageURL) {
                        this.previewurl = this.createCourse.imageURL;
                    }
                    if (this.editCourse.imageURL) {
                        this.createCourse.imageURL = this.editCourse.imageURL;
                    }
                    if (this.previewurl != "") {
                        this.createCourse.imageURL = this.previewurl;
                    }
                    if (this.editCourse.slideDeckFileName || (this.slideDeckFileName != "")) {
                        this.createCourse.slideDeckFileName = this.editCourse.slideDeckFileName;
                        this.createCourse.slideDeckFileNameOriginal = this.editCourse.slideDeckFileNameOriginal;
                        if (this.slideDeckFileName != "") {
                            this.createCourse.slideDeckFileName = this.slideDeckFileName;
                        }
                    }
                    this.populateCreateCourseForPreview(url);
                }
                else {
                    this.createCourse.imageURL = null;
                    this.createCourse.slideDeckFileName = null;
                    this.populateCreateCourseForPreview(url);
                }
            }
        }
        else {
            //  alert("Please Select Course Duration Dates");
        }
        console.log("this.createCourse", this.createCourse);
    };
    CreatecourseComponent.prototype.uploadDoc = function (url) {
        var _this = this;
        if (this.formDataDoc != null) {
            console.log('uploadDoc true');
            //this.showSpinner = true;
            this.showOnlyOverlay = true;
            this.showErrorMessageTitle = 'Info!!';
            this.showErrorMessages.push("Please wait... Uploading document...");
            this.isValidationError = false;
            this.showErrorPopupWidthInPercentage = "100%";
            this.showErrorModalDialog = true;
            this.isSignUp = true;
            this.pleaseWait = true;
            var ss5 = this.dashboardService.courseDocUpload(this.formDataDoc).subscribe(function (data) {
                _this.showSpinner = false;
                _this.createCourse.slideDeckFileName = data;
                _this.formDataDoc = null;
                console.log("Successfully Uploaded the Doc. The this.createCourse.slideDeckFileName ==>" + _this.createCourse.slideDeckFileName);
                _this.closeErrorPopup();
                _this.populateCreateCourseForPreview(url);
            }, function (error) {
                _this.showSpinner = false;
                _this.formDataDoc = null;
                _this.createCourse.slideDeckFileName = null;
                console.log("Could not upload the doc. The this.createCourse.slideDeckFileName ==>" + _this.createCourse.slideDeckFileName);
                _this.closeErrorPopup();
                _this.createInfoAlert("There was an error uploading the Session Doc.");
            });
            this.subscriptions.push(ss5);
        }
        else {
            if (this.editCourse.imageURL || (this.previewurl != "") || this.createCourse.imageURL
                || this.editCourse.slideDeckFileName || (this.slideDeckFileName != "")) {
                if (this.createCourse.imageURL) {
                    this.previewurl = this.createCourse.imageURL;
                }
                if (this.editCourse.imageURL) {
                    this.createCourse.imageURL = this.editCourse.imageURL;
                }
                if (this.previewurl != "") {
                    this.createCourse.imageURL = this.previewurl;
                }
                if (this.editCourse.slideDeckFileName || (this.slideDeckFileName != "")) {
                    this.createCourse.slideDeckFileName = this.editCourse.slideDeckFileName;
                    this.createCourse.slideDeckFileNameOriginal = this.editCourse.slideDeckFileNameOriginal;
                    if (this.slideDeckFileName != "") {
                        this.createCourse.slideDeckFileName = this.slideDeckFileName;
                    }
                }
                this.populateCreateCourseForPreview(url);
            }
            else {
                this.createCourse.imageURL = null;
                this.createCourse.slideDeckFileName = null;
                this.populateCreateCourseForPreview(url);
            }
        }
    };
    CreatecourseComponent.prototype.getEndDate = function (startDate, startTime, duration) {
        console.log('getEndDate:param startDate==>' + startDate + 'startTime==>' + startTime + 'duration==>' + duration);
        var durationHours = parseInt(duration.split(":")[0]);
        var durationMinutes = parseInt(duration.split(":")[1]);
        console.log('getEndDate:durationHours' + durationHours);
        console.log('getEndDate:durationMinutes' + durationMinutes);
        console.log('getEndDate:The end date before :');
        var endDate = moment(startDate + " " + startTime + ':00'); //.add(durationHours, 'hours').add(durationMinutes, 'minutes');
        console.log(endDate);
        endDate = endDate.add(durationHours, 'hours').add(durationMinutes, 'minutes');
        console.log('getEndDate:The end date after :');
        console.log(endDate);
        return endDate;
    };
    CreatecourseComponent.prototype.populateCourseEndDateAndTime = function () {
        this.endDateTime = this.getEndDate(moment(this.createCourse.StartDate).format('MM/DD/YYYY').toString(), this.start, this.duration)
            .format('MM/DD/YYYY HH:mm:ss').toString();
        console.log('populateCourseEndDateAndTime:endDateTime=' + this.endDateTime);
        this.createCourse.EndDate = moment(this.endDateTime.split(" ")[0]).toDate();
        console.log('this.createCourse.EndDate');
        console.log(this.createCourse.EndDate);
        this.end = this.endDateTime.split(" ")[1].substring(0, 5);
        /*this.time.forEach(element => {
          if(element.display == this.end){
            this.createCourse.endTime.timeId = element.timeId;
          }
        });*/
        this.createCourse.endTime.hour = this.end.split(":")[0];
        this.createCourse.endTime.minute = this.end.split(":")[1];
        this.createCourse.endTime.hourMinuteSeparator = ":";
    };
    CreatecourseComponent.prototype.populateCreateCourseForPreview = function (url) {
        var _this = this;
        this.createCourse.displayStartDateOnly = moment(this.createCourse.StartDate).format('MM/DD/YYYY').toString();
        this.createCourse.displayStopDateOnly = moment(this.createCourse.EndDate).format('MM/DD/YYYY').toString();
        this.createCourse.displayStartDate = moment(this.createCourse.StartDate).format('MM/DD/YYYY').toString() + " " + this.start + ":00";
        this.createCourse.displayStopDate = moment(this.createCourse.EndDate).format('MM/DD/YYYY').toString() + " " + this.end + ":00";
        this.createCourse.courseStartDateStr = moment(this.createCourse.StartDate).format('MM/DD/YYYY').toString() + " " + this.start + ":00";
        this.createCourse.courseEndDateStr = moment(this.createCourse.EndDate).format('MM/DD/YYYY').toString() + " " + this.end + ":00";
        this.createCourse.courseScheduleEndDateStr = this.createCourse.currentSchedule.endDate;
        this.createCourse.courseStatus = "Submitted";
        this.createCourse.courseCreateTime = null;
        this.createCourse.courseLastUpdateTime = null;
        this.createCourse.courseDuration = 0;
        this.createCourse.courseStartDTime = null;
        this.createCourse.courseEndDTime = null;
        this.createCourse.courseEventDesc = null;
        this.createCourse.approvedByUser = null;
        this.createCourse.countryForTimeZone = null;
        this.createCourse.numberOfAttendees = 0;
        this.createCourse.meetingUrl = null;
        this.createCourse.createdByUserName = null;
        this.createCourse.profilePicName = null;
        this.createCourse.severity = "green";
        this.createCourse.creator = null;
        this.createCourse.courseCreatorImageURL = "https://s3.amazonaws.com/uvsityImages/profilebig.png";
        this.createCourse.webexMeetingKey = "";
        this.createCourse.webexGuestToken = "";
        this.createCourse.webexHostMeetingRequest = null;
        this.createCourse.webexAttendeeMeetingRequest = null;
        this.createCourse.webexHostUrl = null;
        this.createCourse.webexAttendeeUrl = null;
        this.createCourse.webexPassword = null;
        if (!this.createCourse.similarCourseId) {
            this.createCourse.similarCourseId = null;
        }
        this.createCourse.userType = null;
        this.createCourse.courseAttendeeStatus = null;
        this.createCourse.review = null;
        this.createCourse.reviewCount = 0;
        this.createCourse.avgReview = 0;
        this.createCourse.avgReviewIntValue = 0;
        this.createCourse.reviewComment = null;
        this.createCourse.courseInfos = null;
        this.createCourse.active = false;
        this.createCourse.owner = true;
        this.createCourse.userLoggedIn = true;
        this.createCourse.userRegistered = false;
        this.createCourse.users = [];
        this.createCourse.currentSchedule.repeatcheckbox = this.repeatcheckbox;
        if (this.repeatcheckbox == 'false' || this.repeatcheckbox == '') {
            this.createCourse.currentSchedule.repeatTypeStr = 'None';
        }
        console.log(this.createCourse);
        this.showSpinner = true;
        var s6 = this.dashboardService.userSummary1().subscribe(function (data) {
            _this.showSpinner = false;
            _this.createCourse.user = data;
            _this.createCourse.createdByUser = data.userDetailsId;
            _this.data.storage = {
                coursepreview: {
                    coursedata: _this.createCourse
                }
            };
            console.log('Before going to Preview CourseData==>' + _this.data.storage.coursepreview.coursedata);
            _this.editCourse = {};
            _this.router.navigate([url]);
        }, function (error) {
            _this.showSpinner = false;
            _this.handleError(error);
        });
        this.subscriptions.push(s6);
    };
    CreatecourseComponent.prototype.populateCreateCourseForEndDate = function () {
        var courseForEndDate = {
            timeZone: this.createCourse.timeZone,
            startTime: this.createCourse.startTime,
            endTime: this.createCourse.endTime,
            currentSchedule: {
                repeateEveryCount: this.createCourse.currentSchedule.repeateEveryCount,
                monthlyRepeatTypeStr: this.createCourse.currentSchedule.monthlyRepeatTypeStr,
                endOfMeetingTypeStr: this.createCourse.currentSchedule.endOfMeetingTypeStr,
                isScheduleValid: this.createCourse.currentSchedule.isScheduleValid,
                occurence: this.createCourse.currentSchedule.occurence,
                repeatTypeStr: this.createCourse.currentSchedule.repeatTypeStr,
                selectedDaysOfWeekStr: this.createCourse.currentSchedule.selectedDaysOfWeekStr
            },
            courseStartDateStr: moment(this.createCourse.StartDate).format('MM/DD/YYYY').toString() + " " + this.start + ":00",
            courseEndDateStr: moment(this.createCourse.StartDate).format('MM/DD/YYYY').toString() + " " + this.end + ":00",
            courseScheduleEndDateStr: this.createCourse.currentSchedule.endDate
        };
        console.log("The Course Structure before sending to calculate Course End Date:");
        console.log(courseForEndDate);
        return courseForEndDate;
    };
    CreatecourseComponent.prototype.startTime = function (value) {
        var _this = this;
        this.time.forEach(function (element) {
            if (element.timeId == value) {
                _this.start = element.display;
                var _a = element.display.split(':'), hour = _a[0], minute = _a[1];
                _this.createCourse.startTime.hour = hour;
                _this.checkTime(element, false);
                _this.createCourse.startTime.minute = minute;
                _this.createCourse.startTime.hourMinuteSeparator = ":";
            }
        });
    };
    CreatecourseComponent.prototype.formatTime = function (time) {
        var hours = time.hour;
        var AmOrPm = hours >= 12 ? 'PM' : 'AM';
        hours = (hours % 12) || 12;
        var minutes = time.minute;
        return hours + ":" + minutes + " " + AmOrPm;
    };
    CreatecourseComponent.prototype.checkTime = function (time, isHour) {
        // Create date from input value
        var inputDate = new Date(this.createCourse.StartDate);
        // Get today's date
        var todaysDate = new Date();
        // call setHours to take the time out of the comparison
        if (inputDate.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
            var dateTime = new Date();
            var hh = dateTime.getHours() + 1;
            var hour = (isHour) ? Number(hour) : Number(time.hour);
            console.log("hh", hh);
            console.log("time.hour", hour);
            if (hh < hour) {
                this.wrongTime = false;
            }
            else {
                this.wrongTime = true;
            }
        }
        else {
            this.wrongTime = false;
        }
    };
    CreatecourseComponent.prototype.dateSelected = function (e) {
        this.checkTime(this.createCourse.startTime.hour, true);
    };
    CreatecourseComponent.prototype.endTime = function (value) {
        var _this = this;
        this.time.forEach(function (element) {
            if (element.timeId == value) {
                _this.end = element.display;
                _this.duration = _this.end;
                var _a = element.display.split(':'), hour = _a[0], minute = _a[1];
                _this.createCourse.endTime.hour = hour;
                _this.createCourse.endTime.minute = minute;
                _this.createCourse.endTime.hourMinuteSeparator = ":";
            }
        });
    };
    CreatecourseComponent.prototype.validateDates = function () {
        var startDate = this.createCourse.StartDate;
        var startTime = this.start;
        var endTime = this.end;
        var isModalDialogVisible = false;
        var showErrorMessages = [];
        var errors = { _body: {}, url: "Internal" };
        if (startDate == undefined || startDate == null || startDate == '') {
            console.log("Please select the Course Start Date.");
            showErrorMessages.push("Please select the Session Start Date.");
            isModalDialogVisible = true;
        }
        if (startTime == undefined || startTime == null || startTime == '') {
            console.log("Please select the Course Start Time.");
            showErrorMessages.push("Please select the Session Start Time.");
            isModalDialogVisible = true;
        }
        if (endTime == undefined || endTime == null || endTime == '') {
            console.log("Please select the Duration.");
            showErrorMessages.push("Please select the Duration.");
            isModalDialogVisible = true;
        }
        this.populateCourseEndDateAndTime();
        if (!isModalDialogVisible) {
            var courseStartDateStr = moment(this.createCourse.StartDate).format('MM/DD/YYYY').toString() + " " + this.start + ":00";
            var courseEndDateStr = moment(this.createCourse.EndDate).format('MM/DD/YYYY').toString() + " " + this.end + ":00";
            if (moment(courseStartDateStr).isBefore(moment(new Date()))) {
                showErrorMessages.push("Please chose the Session Start Date/Time so that it's value is greater than the current time.");
                isModalDialogVisible = true;
            }
            if (moment(courseEndDateStr).isBefore(moment(courseStartDateStr))) {
                showErrorMessages.push("Please chose the Session End Date/Time so that it's value is greater than the Session Start Date/Time.");
                isModalDialogVisible = true;
            }
        }
        if (isModalDialogVisible) {
            var errorMsgString = "";
            showErrorMessages.forEach(function (errMsg) {
                errorMsgString = errorMsgString + '"' + errMsg + '"' + ',';
            });
            errorMsgString = errorMsgString.substring(0, errorMsgString.length - 1);
            errorMsgString = '{' + '"' + "Uvsity_Errors" + '"' + ':' + '[' + errorMsgString + ']}';
            ;
            console.log("THe errorMsgString ==>" + errorMsgString);
            errors._body = errorMsgString;
            //errors._body.Uvsity_Errors = showErrorMessages;
            this.handleError(errors);
            return false;
        }
        return true;
    };
    CreatecourseComponent.prototype.handleError = function (error) {
        this.showSpinner = false;
        console.log("The error inside the Error Handler==>");
        console.log(error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    CreatecourseComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    CreatecourseComponent.prototype.privateTypeSelected = function () {
        console.log("in private course");
        this.createInfoAlert("You are going to create a private session. This session will not appear in session search and viewable by the public users");
    };
    CreatecourseComponent.prototype.QuestionnaireEvent = function (type) {
        if (type == 'add') {
            this.questionnairePopup = true;
        }
        else if (type == 'edit') {
            this.questionnairePopup = true;
        }
    };
    CreatecourseComponent.prototype.questionnaireClose = function (e) {
        this.questionnairePopup = false;
        console.log("questionnaire", e);
        if (e.success) {
            if (this.createCourse.registrationQuestionnaireId == 0 || this.createCourse.registrationQuestionnaireId == null) {
                this.createCourse.registrationQuestionnaireId = e.identifier;
            }
            if (e.isdeleted) {
                this.createCourse.registrationQuestionnaireId = null;
            }
        }
    };
    CreatecourseComponent.prototype.createInfoAlert = function (alert) {
        var infoAlert = {
            isInfo: true,
            infoMessage: alert,
            url: "not required"
        };
        this.handleError(infoAlert);
    };
    return CreatecourseComponent;
}());
export { CreatecourseComponent };
//# sourceMappingURL=createcourse.component.js.map